import { Select, Typography } from 'antd';

const { Text } = Typography;
const { Option } = Select;


const PointSelector = ({ exploitationPoints, selectedPoint, onPointChange }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
      <Text strong>Sélectionnez le point :</Text>
      <Select
        className="w-full sm:w-48"
        value={selectedPoint?.point_number}
        onChange={onPointChange}
      >
        {exploitationPoints.map((point) => (
          <Option key={point.point_number} value={point.point_number}>
            Point {point.point_number}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default PointSelector;